var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
import { ConvenienceEquipmentDto } from '../../../classes/convenience-equipment';
export class ReservationConvenienceDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.convenienceEquipmentId = initializer.convenienceEquipmentId;
        this.fee = initializer.fee;
        this.quantity = initializer.quantity;
        this.directPaymentPrice = initializer.directPaymentPrice;
        this.memo = initializer.memo;
        this.convenienceEquipment = initializer.convenienceEquipment;
    }
}
__decorate([
    Type(() => ConvenienceEquipmentDto),
    __metadata("design:type", ConvenienceEquipmentDto)
], ReservationConvenienceDto.prototype, "convenienceEquipment", void 0);
